import React from "react";
import BaseModel from "../models/BaseModel";
import BaseModelMap from "../models/BaseModelMap";
import FloorDialog from "../modelDialogs/FloorDialog";
import type Floor from "../models/Floor";
import TreeViewModel from "../models/TreeviewModel";
import type Page from "../models/Page";
import Logger from "../Logger";
import { ApplicationMode } from "../models/SettingsEnums";

const logger = new Logger();

export default class FloorsTreeViewModel extends TreeViewModel {
  page?: Page;

  constructor(obj: BaseModel) {
    super(obj);
  }

  get typedObj(): BaseModelMap<Floor> {
    return this.obj as BaseModelMap<Floor>;
  }

  get isSelectable(): boolean {
    return false;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return false;
  }

  getDisableEdit(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    return this.typedObj.sortBy("tagOrName");
  }

  handleAdd() {
    state.dialogManager.openDialog(<FloorDialog parent={this.typedObj} />);
  }

  ////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // inline menu buttons
  //
  ////////////////////////////////////////////////////////////////////////////////////////

  getButtons(): JSX.Element[] | undefined {
    if (state.settings.applicationMode === ApplicationMode.ConceptOne && state.projectMetadata.isC1Project && state.c1.editMode.value !== "building") return [];
    return [this.inlineButton_Add("ContextMenuLables.addFloors")]; // no itx
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // context menu
  //
  ////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////////////////////

  canBePastedInteractive(copiedObjClassName: string): boolean {
    if (copiedObjClassName == "Floor") {
      return true;
    }
    return false;
  }

  async getDisabledContextMenuItems(): Promise<Array<string>> {
    const copiedObjClassName = state.clipboard.getClassName();

    if (copiedObjClassName && copiedObjClassName == "Floor") {
      return new Array<string>();
    }

    return ["paste"]; // no itx
  }

  get contextMenuItems(): any {
    var subLabelPaste = undefined;

    try {
      subLabelPaste = state.contextMenuManager.clipboardData.items[0].name;
    } catch (ex) {
      logger.error(ex);
    }

    return {
      title: this.obj?.name,
      items: [
        this.baseContextMenuItems_Paste(subLabelPaste),
        this.baseContextMenuItems_Add("ContextMenuLables.addFloors"), // no itx
      ],
    };
  }
}
